/* eslint-disable react/prop-types */
import { UploadOutlined, CloseOutlined } from '@ant-design/icons';
import { AutoComplete, Dropdown, Menu, Progress, Select } from 'antd';
const { Option } = Select;
import { Form, Formik } from 'formik';
import 'moment-timezone';
import { Bars } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth, useFeatureEntitlements } from '@frontegg/react';
import {
  ExpandIcon,
  ManageViewsIcon,
  PlusIcon,
  RecentSearchIcon,
  SearchIcon,
  TagIcon,
} from 'src/icons';
import { filteredApptsTotalSlice } from 'src/store/slices/appointments.slice';
import {
  ProfileLogo,
  TreeSelectDropdown,
} from '../../../components/baseComponents';
import { Table } from '../../../components/groupComponents';
import { AddNewAppointment } from './AddNewAppointment';
import AppointmentsCSVUploader from './AppointmentsCSVUploader';
import { DeleteAppointment } from '../../../components/pageComponents/Delete.Appointment';
import { EditAppointment } from '../../../components/pageComponents/EditAppointmentPage';
import { ManageViewModal } from '../../../components/pageComponents/ManageView.Modal';
import ModalPopup from '../../../components/pageComponents/ModalPopup';
import NotificationHistory from '../../../components/pageComponents/NotificationHistory';
import { SavedSearchModal } from '../../../components/pageComponents/SaveSearch.Modal';
import { ShowQRCode } from '../../../components/pageComponents/ShowQRCode.Appointment';
import moment from 'moment-timezone';
import { useState } from 'react';
import { columns } from './AppointmentMobileColumnStructure';
import { addRecentSearchAction } from '../../../store/actions/appointment.action';
import { showToastSuccess } from '../../../utilities/toast';
import { analytics } from 'src/services';
import { isEmpty } from 'lodash';
import { getDateRangeForFilter } from '../utils/helpers';

const AppointmentsMobilePage = ({
  // doctor_nameSorter,
  onCellClick,
  filteredData,
  filterValue,
  showNoData,
  isfilterOn,
  isModalOpen,
  handleCancel,
  setIsModalOpen,
  startIndex,
  showUpload,
  setShowUpload,
  showModal,
  deleteText,
  QRCodeURL,
  editAppointmentOpen,
  apptsAPICall,
  isLoading,
  setFilteredData,
  getAppointmentStatusList,
  filteredPatientNames,
  filteredApptsTotal,
  apptsTotal,
  beforepercent,
  itemsPerPage,
  handleShowMore,
  // getReminderTime,
  setEditAppointmentOpen,
  isDeleteOpen,
  onChangeHandler,
  setIsDeleteOpen,
  filterOptions,
  setIsFilterOn,
  setShowNoData,
  setFilteredPatientNames,
  setFilterValue,
  hasMultiplePractitionersWithSameName,
  isCustomSelected,
  performFuzzySearch,
  setPatientSearchKeyword,
  isQRCodeOpen,
  setIsQRCodeOpen,
  isnotificationHistoryOpen,
  setIsnotificationHistoryOpen,
  storeRecord,
  selectedPractitioners,
  setSelectedPractitioners,
  fetchCounterRef,
  setpractitionerSearchKeyword,
  setUploadKey,
  myAppointments,
  setMyAppointments,
  recentSearchList,
  handleAddLabel,
  handleRecentSearchSelect,
  handleCurrentPractitionerNext7Days,
  setDateValue,
  parseStoredNames,
  showProfileLogo,
  setShowProfileLogo,
  currentDate,
  handleMonthChange,
  handleYearChange,
  isModalVisible,
  handleSaveView,
  handleCloseView,
  savePatientName,
  saveDate,
  saveStatus,
  setRenameTitle,
  renameTitle,
  isMangeViewOpen,
  handleMangeViews,
  selectedTitle,
  setSelectedTitle,
  handleCloseManageView,
  handleSaveAppDuplicate,
  duplicateError,
  setDuplicateError,
  handleReset,
  showDropdown,
  setShowDropdown,
  resetDateFilter,
  setResetDateFilter,
  getAppointmentByFilter,
  setSelectedFilters,
  selectedFilters,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  remainderPatientAppts,
  showPatientResetLink,
  setDeleteText,
  setQRCodeURL,
  setStoreRecord,
  setShowConvertAppointmentToAuraModal,
  setData,
  setSelectedAppointmentForAuraEncounter,
}) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const nonVCAIntakeStatus = 'Aura Only';
  const { isEntitled: hasVCAProcessedWorkflowAccess } = useFeatureEntitlements(
    'vca-processed-status'
  );
  const { practitionersAndPatients } = useSelector(
    (state) => state?.appointmentState
  );
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const { allPractitionersNames, settingsOrgValue } = useSelector(
    (state) => state?.appointmentState
  );
  const [selectDates, setSelectDates] = useState([null, null]);

  const statusOptions = [
    {
      title: 'All',
      value: 'All',
      className:
        'flex justify-center items-center h-8 rounded-full hover:bg-[#f7f7f7]',
    },
    {
      title: 'Completed',
      value: 'Completed',
      className:
        'text-[#1ec990] bg-[#eefaf4] flex items-center justify-center rounded-full hover:bg-[#A2EFC9]  h-8',
    },
    ...(hasVCAProcessedWorkflowAccess
      ? [
          {
            title: 'Processed',
            value: 'processed',
            className:
              'text-[#4d38ca] bg-[#edf0ff] flex items-center justify-center rounded-full hover:bg-[#c7cefe] status-options h-8',
          },
        ]
      : []),
    {
      title: 'In Progress',
      value: 'InProgress',
      className:
        'text-[#ff6f00] bg-[#ffe1ca] flex items-center justify-center rounded-full hover:bg-[#F7CFB1]  h-8',
    },
    {
      title: 'Not Started',
      value: 'New',
      className:
        'text-[#5a8dda] bg-[#e7f1ff] flex items-center justify-center rounded-full hover:bg-[#BCD4F7] status-options h-8',
    },
    {
      title: nonVCAIntakeStatus,
      value: 'Unavailable',
      className:
        'text-[#018749] bg-[#caffca] flex items-center justify-center rounded-full hover:bg-[#a8ffa8] status-options h-8',
    },
    {
      title: 'Partial Summary',
      value: 'partial_completed',
      className:
        'text-[#ff6f00] bg-[#ffe1ca] flex items-center justify-center rounded-full hover:bg-[#F7CFB1]  h-8',
    },
  ];

  const handleSetDefault = (selectedRecord) => {
    const updatedSearches = (recentSearchList?.search_preference || []).map(
      (record) => {
        if (record.id === selectedRecord.id) {
          return { ...record, isDefaultAppointmentView: true };
        }

        return { ...record, isDefaultAppointmentView: false };
      }
    );

    dispatch(addRecentSearchAction(updatedSearches, 'appointments'));

    showToastSuccess('Default preference updated');
  };

  const addAppointmentOptions = () => {
    return (
      <Menu>
        <Menu.Item
          className="font-sans"
          key="bulk-upload"
          onClick={() => {
            setShowUpload(true);
            setUploadKey((prevKey) => prevKey + 1); // Increment the key to trigger re-render
            analytics.track('Clicked Bulk Upload Appointments', {
              email: user?.email,
            });
          }}
        >
          <span className="flex items-center gap-2">
            <UploadOutlined className="mr-1" /> Bulk upload appointments
          </span>
        </Menu.Item>
      </Menu>
    );
  };

  const getFilteredPractitioners = () => {
    if (
      isEmpty(practitionersAndPatients?.practitioner) ||
      isEmpty(allPractitionersNames) ||
      !allPractitionersNames.filter
    ) {
      return [];
    }

    const shownPractitionerIds = new Set(
      allPractitionersNames
        ?.filter((practitioner) => practitioner.is_shown === true)
        ?.map((practitioner) => practitioner.practitioner_id)
    );

    if (
      settingsOrgValue?.has_appointments &&
      currentPractitioner?.practitioner_id
    ) {
      shownPractitionerIds.add(currentPractitioner.practitioner_id);
    }

    return (
      practitionersAndPatients?.practitioner?.filter((practitioner) =>
        shownPractitionerIds.has(practitioner.practitioner_id)
      ) || []
    );
  };

  const filteredPractitioners = getFilteredPractitioners();

  return (
    <div className={`page-wrapper appointment-page`}>
      <Formik
        initialValues={{ gender: '' }} // Initial form values
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className=" w-full xl:w-1/5 2xl:w-1/5 drop-shadow-sm bg-white rounded-xl practitioner-dropdown">
                <Select
                  // open
                  suffixIcon={<ExpandIcon fill={'#000000'} />}
                  mode="multiple"
                  bordered={false}
                  className={`border-none w-full overflow-auto font-sans grid grid-cols-0 items-center focus:outline-none  py-1 ${selectedPractitioners.length === 0 ? 'h-10 flex items-center' : ''}`}
                  filterOption={(inputValue, option) =>
                    option.label
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) !== -1
                  }
                  placeholder={
                    filteredPractitioners?.length > 0
                      ? 'Practitioners'
                      : 'Loading...'
                  }
                  onDropdownVisibleChange={(open) => {
                    // Show the profile logo when the dropdown is opened
                    setShowProfileLogo(open);
                  }}
                  value={
                    filterOptions?.doctorNames?.length > 0
                      ? selectedPractitioners
                      : null
                  }
                  onChange={(value) => {
                    setpractitionerSearchKeyword(value);
                    analytics.track('Selected Practitioner Filter', {
                      practitioner_name: value,
                      email: user?.email,
                    });
                    onChangeHandler(value, 'doctorName');
                    setSelectedPractitioners(value);
                  }}
                  // onChange={(value) => {
                  //     const uniqueValues = Array.from(new Set(value)); // Remove duplicates
                  //     setpractitionerSearchKeyword(uniqueValues);
                  //     analytics.track("Selected Practitioner Filter", { practitioner_name: uniqueValues });
                  //     onChangeHandler(uniqueValues, "doctorName");
                  //     setSelectedPractitioners(uniqueValues);
                  // }}
                  optionFilterProp="label"
                  showSearch
                >
                  {filteredData?.length > 0 && (
                    <>
                      {/* {practitionersAndPatients?.practitioner && (
                                                    <Select.Option value="All">All</Select.Option>
                                                )} */}
                      {filteredPractitioners?.map((names) => (
                        <Select.Option
                          key={names.id}
                          value={names.practitioner_id}
                          email={names.email}
                          label={names.practitioner_firstName}
                        >
                          <div className="font-sans flex">
                            <div className="flex items-center">
                              {!selectedPractitioners?.includes(
                                names?.practitioner_id
                              ) &&
                                showProfileLogo && (
                                  <ProfileLogo
                                    filteredData={filteredData}
                                    practitionersAndPatients={
                                      practitionersAndPatients
                                    }
                                    name={`${names.first_name} ${names.last_name}`}
                                    className={
                                      'profile-popover-logo mr-1 sm:mr-2 lg:mr-3'
                                    }
                                    practitioner_name={names?.practitioner_Name}
                                  />
                                )}

                              <div className="">
                                {names.practitioner_firstName}
                                {hasMultiplePractitionersWithSameName(
                                  names.practitioner_firstName
                                ) && (
                                  <div
                                    style={{
                                      color: 'grey',
                                      fontSize: 'smaller',
                                      fontFamily: 'Poppins',
                                    }}
                                  >
                                    {selectedPractitioners &&
                                      !selectedPractitioners.includes(
                                        names?.practitioner_id
                                      ) && (
                                        <span>{names.practitioner_email}</span>
                                      )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Select.Option>
                      ))}
                    </>
                  )}
                </Select>
              </div>
              <div className=" w-full ant-select-selector xl:w-1/5 2xl:w-1/5  drop-shadow-sm bg-white rounded-xl">
                <AutoComplete
                  bordered={false}
                  className="border-none font-sans h-10 text-base flex items-center w-full border-0 focus:outline-none placeholder-gray-500 pr-4"
                  style={{ WebkitTextFillColor: 'gray' }}
                  options={
                    showDropdown &&
                    (showNoData
                      ? [
                          {
                            value: 'No data',
                            label: 'No data',
                            disabled: true,
                          },
                        ]
                      : filteredPatientNames.map((patient) => ({
                          ...patient,
                          value: `${patient.value}_${patient.patient_id}`,
                          label: (
                            <div>
                              <div>{patient.value}</div>
                              <div className="flex flex-row justify-start gap-2">
                                <div className="text-[11px] text-[#777777]">
                                  DOB: {patient.patient_dob}
                                </div>
                                <div className="text-[11px] text-[#777777]">
                                  Patient ID: {patient.patient_id}
                                </div>
                              </div>
                              {patient.appointment_date && (
                                <div
                                  className={`text-[11px] ${
                                    moment(patient.appointment_date).isBefore(
                                      moment(),
                                      'day'
                                    )
                                      ? 'text-[#ff0000]'
                                      : 'text-[#16a878]'
                                  }`}
                                >
                                  {moment(patient.appointment_date).isBefore(
                                    moment(),
                                    'day'
                                  )
                                    ? `Past appt.: ${patient.appointment_date}`
                                    : `Next appt.: ${patient.appointment_date}`}
                                </div>
                              )}
                            </div>
                          ),
                        })))
                  }
                  placeholder="Patient"
                  filterOption={false}
                  value={
                    isfilterOn
                      ? filterValue?.patientName
                        ? filteredPatientNames.find(
                            (opt) => opt.id === filterValue.patientName
                          )?.id || filterValue?.patientName
                        : ''
                      : ''
                  }
                  suffixIcon={
                    isfilterOn && filterValue?.patientName ? (
                      <CloseOutlined
                        onClick={() => {
                          setIsFilterOn(false);
                          onChangeHandler('', 'patientName');
                          setPatientSearchKeyword('');
                          setShowDropdown(false);
                          setShowNoData(false);
                        }}
                        className="text-gray-700"
                      />
                    ) : (
                      <SearchIcon />
                    )
                  }
                  onChange={(value, option) => {
                    setPatientSearchKeyword(option?.id || value);
                    setShowDropdown(false);
                    // isfilterOn Set to true only if value is not empty
                    setIsFilterOn(!!option?.id || !!value);
                    // Filter patient names based on user input
                    const filteredNames = performFuzzySearch(
                      option?.id || value
                    );

                    // Set the showNoData flag if there are no matching names
                    setShowNoData(filteredNames?.length === 0);
                    setFilteredPatientNames(filteredNames);

                    // If the user tries to select "No data," clear the selection
                    if (
                      option?.id
                        ? option?.id?.toLowerCase() === 'no data'
                        : value?.toLowerCase() === 'no data'
                    ) {
                      onChangeHandler('', 'patientName');
                    } else {
                      onChangeHandler(
                        option?.id || value,
                        'patientName',
                        null,
                        option?.patient_id
                      );
                      setShowDropdown(true);
                    }
                  }}
                  dropdownStyle={{ width: '232px' }}
                />
              </div>
              {/* <div className="bg-white p-1 rounded-xl drop-shadow-sm flex items-center tree-dropdown">
                            <CalendarIcon className="mr-2 ml-1 text-black whitespace-nowrap" />
                                     <div className="flex flex-col md:flex-row gap-3 justify-between items-center flex-nowrap ">
                                         <div className=" grow shrink-0 w-full ">
                                         <TreeSelectDropdown
                                                        name="datefilter"
                                                        showSearch={false}
                                                        bordered={false}
                                                        className="h-8 !w-32 bg-transparent border-none focus:border-none rounded-xl focus:bg-gray-100 caret-transparent flex items-center hover:bg-gray-100"
                                                        options={DateOptions}
                                                        value={filterValue?.datefilter || dateValue || "All time" || ""}
                                                        onChange={(value, valueString) => {
                                                            setDateValue(value);
                                                            onChangeHandler(
                                                                value,
                                                                "datefilter",
                                                                valueString
                                                            )
                                                        }}
                                                        popupClassName={"!w-36"}

                                                    >
                                                    </TreeSelectDropdown>
                                            </div>
                                        </div>
                                    <div>
                                    <CustomRangePicker
                                             visible={modalVisible && isCustomSelected}
                                             onCancel={handleCancelModal}
                                             onChangeHandler={onChangeHandler}
                                             filterValue={filterValue}
                                             setFilterValue={setFilterValue}
                                             setModalVisible={setModalVisible}
                                    />
                                </div>
                            </div>  */}

              <div className="" style={{ position: 'relative', zIndex: '10' }}>
                <ModalPopup
                  currentDate={currentDate}
                  handleMonthChange={handleMonthChange}
                  handleYearChange={handleYearChange}
                  onChangeHandler={onChangeHandler}
                  isfilterOn={isfilterOn}
                  dateValue={filterValue?.datefilter}
                  setFilterValue={setFilterValue}
                  filterValue={filterValue}
                  resetDateFilter={resetDateFilter}
                  setResetDateFilter={setResetDateFilter}
                  selectDates={selectDates}
                  setSelectDates={setSelectDates}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                />
              </div>

              <div className="bg-white p-1 rounded-xl drop-shadow-sm flex items-center tree-dropdown">
                <label
                  htmlFor="appointments"
                  className="mr-1 ml-2 text-sm text-black whitespace-nowrap"
                >
                  Status
                </label>
                <div className="flex flex-col md:flex-row gap-3 justify-between items-center flex-nowrap ">
                  <div className=" grow shrink-0 w-full ">
                    <TreeSelectDropdown
                      suffixIcon={
                        <ExpandIcon
                          fill={'#000000'}
                          className="-mr-2 absolute right-0 "
                        />
                      }
                      name="datefilter"
                      showSearch={false}
                      bordered={false}
                      className="h-8 !w-40 bg-transparent border-none focus:border-none rounded-xl focus:bg-gray-100 caret-transparent flex items-center hover:bg-gray-100 pr-2 placeholder:text-sm text-center"
                      placeholder={'All'}
                      value={
                        isfilterOn && filterValue?.status !== null
                          ? filterValue?.status?.includes('intake-')
                            ? filterValue?.status?.split('-')[1]
                            : filterValue?.status
                          : ''
                      }
                      options={statusOptions}
                      onChange={(value) =>
                        onChangeHandler(`intake-${value}`, 'status')
                      }
                      popupClassName={'!w-36'}
                    ></TreeSelectDropdown>
                  </div>
                </div>
              </div>

              <div className="w-full h-10 flex items-center drop-shadow-sm bg-white rounded-xl text-sm practitioner-dropdown">
                <div className="ml-2">
                  <RecentSearchIcon />
                </div>
                <Select
                  suffixIcon={<ExpandIcon fill={'#000000'} />}
                  // dropdownStyle={{ width: '300px' }}
                  bordered={false}
                  className="border-none truncate font-sans h-10 text-base flex items-center w-full border-0 focus:outline-none pr-4"
                  value={
                    renameTitle ||
                    myAppointments ||
                    selectedTitle ||
                    'Custom search'
                  }
                  optionFilterProp="label"
                  showSearch={false}
                >
                  <Option disabled key="next-7-days">
                    <button
                      type="button"
                      className="w-full py-2 px-1 hover:bg-gray-100 rounded-md text-left"
                      onClick={(e) => {
                        handleCurrentPractitionerNext7Days();
                        const newValue = 'My appointments in next 7 days';
                        setMyAppointments(newValue);
                        localStorage.setItem(
                          `${currentPractitioner?.org_uuid}_myAppointments`,
                          newValue
                        );
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <div className="text-gray-700">
                        My appointments in next 7 days
                      </div>
                    </button>
                  </Option>

                  {!isCustomSelected && (
                    <Option disabled key="save-view">
                      <div className="">
                        <button
                          type="button"
                          className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                          onClick={handleAddLabel}
                          disabled={!isfilterOn}
                        >
                          <TagIcon className="mr-2" fill="#000000" />
                          <span className="text-black">Save this view...</span>
                        </button>
                      </div>
                    </Option>
                  )}
                  <Option disabled key="manage-view">
                    <div className="">
                      <button
                        className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                        type="button"
                        onClick={handleMangeViews}
                      >
                        <ManageViewsIcon className="mr-2" fill="#000000" />
                        <span className="text-black">Manage views...</span>
                      </button>
                    </div>
                  </Option>
                  {Array.isArray(recentSearchList?.search_preference) &&
                    recentSearchList?.search_preference.length > 0 && (
                      <Option disabled key="recent-searches-heading">
                        <div className="text-gray-400">My views</div>
                      </Option>
                    )}
                  {Array.isArray(recentSearchList?.search_preference) &&
                    recentSearchList?.search_preference.map((search, index) => {
                      const uniqueKey = `${search?.practitioners.map((p) => p.practitionerId).join(',')}-${search?.patient}-${search?.date}-${search?.status}-${index}`;
                      return (
                        <Option
                          key={uniqueKey}
                          value={search?.practitioners
                            ?.map((p) => p.practitionerId)
                            .flat()}
                          label={search?.practitioners
                            ?.map((p) => p.practitionerName)
                            .join(', ')}
                        >
                          <button
                            type="button"
                            className="w-full text-left py-1"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleRecentSearchSelect(search);
                              setSelectedTitle(search.title);
                              localStorage.setItem(
                                `${currentPractitioner?.org_uuid}_selectedTitle`,
                                search.title
                              );
                              setMyAppointments('');
                            }}
                          >
                            <div className="flex justify-between gap-1  text-wrap">
                              {search?.title && <div>{search?.title}</div>}
                              {search?.isDefaultAppointmentView ? (
                                <div className="flex auraonly-radio-outlook">
                                  Default View
                                </div>
                              ) : (
                                <button
                                  className="hover:bg-[#E5E8EB] hover:underline underline-offset-2 decoration-black text-black rounded-xl drop-shadow-sm py-[3px] px-[10px] flex items-center shrink-0 font-normal text-[12px]"
                                  onClick={() => handleSetDefault(search)}
                                >
                                  Set as Default
                                </button>
                              )}
                            </div>
                          </button>
                        </Option>
                      );
                    })}
                </Select>
                <SavedSearchModal
                  isModalVisible={isModalVisible}
                  parseStoredNames={parseStoredNames}
                  handleSaveView={handleSaveView}
                  handleCloseView={handleCloseView}
                  savePatientName={savePatientName}
                  saveDate={saveDate}
                  saveStatus={saveStatus}
                  setRenameTitle={setRenameTitle}
                  renameTitle={renameTitle}
                  handleSaveAppDuplicate={handleSaveAppDuplicate}
                  duplicateError={duplicateError}
                  setDuplicateError={setDuplicateError}
                  setSelectedTitle={setSelectedTitle}
                />
                <ManageViewModal
                  setRenameTitle={setRenameTitle}
                  isMangeViewOpen={isMangeViewOpen}
                  handleMangeViews={handleMangeViews}
                  handleCloseManageView={handleCloseManageView}
                  recentSearchList={recentSearchList}
                  renameTitle={renameTitle}
                  selectedTitle={selectedTitle}
                  setFilterValue={setFilterValue}
                  handleReset={handleReset}
                  setSelectedTitle={setSelectedTitle}
                />
              </div>
              <div className="flex justify-between w-full">
                <div className=" w-36">
                  {(localStorage.getItem(
                    `${currentPractitioner?.org_uuid}_selectedFilters`
                  ) !== 'Today' ||
                    filterValue?.doctorName?.length > 0 ||
                    filterValue?.patientName ||
                    filterValue?.status) && (
                    <button
                      className="hover:bg-[#E5E8EB]
                                            hover:underline underline-offset-2 decoration-black h-10 px-4 rounded-xl drop-shadow-sm font-normal text-black text-[13px]"
                      onClick={async () => {
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_selectedPractitioners`
                        );
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_dateValue`
                        );
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_filter_status`
                        );
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_filter_patient_name`
                        );
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_selectedTitle`
                        );
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_myAppointments`
                        );
                        localStorage.removeItem(
                          `${currentPractitioner?.org_uuid}_selectDates`
                        );
                        localStorage.setItem(
                          `${currentPractitioner?.org_uuid}_selectedFilters`,
                          'Today'
                        );
                        setSelectDates([null, null]);
                        dispatch(filteredApptsTotalSlice(null));
                        fetchCounterRef.current = undefined;
                        setSelectedPractitioners([]);
                        setRenameTitle('');
                        setMyAppointments('');
                        setPatientSearchKeyword('');
                        setSelectedTitle('');
                        setDateValue('Today');
                        setIsFilterOn(true);

                        setpractitionerSearchKeyword(null);
                        setResetDateFilter(true);
                        const todayRange = getDateRangeForFilter('Today');
                        setFilterValue({
                          practitionerNames: [],
                          doctorName: [],
                          patientName: '',
                          ...todayRange,
                          datefilter: 'Today',
                          status: '',
                        });
                        await dispatch(
                          getAppointmentByFilter(
                            [],
                            '',
                            todayRange.startDate,
                            todayRange.endDate,
                            '',
                            'normal',
                            startIndex,
                            '',
                            'start_date',
                            'desc'
                          )
                        );
                        analytics.track('Reset Filters', {
                          email: user?.email,
                        });
                      }}
                    >
                      Clear filters
                    </button>
                  )}
                </div>
                <div className="">
                  <AddNewAppointment
                    isOpen={isModalOpen}
                    onCancel={handleCancel}
                    setIsOpen={setIsModalOpen}
                    startIndex={startIndex}
                    isfilterOn={isfilterOn}
                  />
                  <span style={{ position: 'absolute' }}>
                    <AppointmentsCSVUploader
                      visible={showUpload}
                      setVisible={setShowUpload}
                    />
                  </span>
                  {currentPractitioner?.org_settings
                    ?.enable_bulk_appointment_upload ? (
                    <Dropdown.Button
                      type="primary"
                      overlay={addAppointmentOptions()}
                      overlayStyle={{ top: '18rem' }}
                      placement="bottom"
                      rootClassName="add-appointment-dropdown rounded-xl drop-shadow-sm flex bg-[#00D090] hover:bg-[#059669]"
                      trigger={['click']}
                      icon={<ExpandIcon fill={'#ffffff'} />}
                      onClick={showModal}
                    >
                      <div className="add-appointment-div flex">
                        <PlusIcon />
                        <span className="text-white pl-3 font-normal font-sans">
                          Add appointment
                        </span>
                      </div>
                    </Dropdown.Button>
                  ) : (
                    <button
                      className="rounded-xl h-10 items-center p-4 flex bg-[#00D090] hover:bg-[#059669]"
                      onClick={showModal}
                    >
                      <div className=" flex items-center">
                        <PlusIcon />
                        <span className="text-white pl-3 font-normal font-sans">
                          Add appointment
                        </span>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {deleteText && (
              <div className="">
                <DeleteAppointment
                  isOpen={isDeleteOpen}
                  onCancel={() => setIsDeleteOpen(false)}
                  setIsOpen={setIsDeleteOpen}
                  deleteText={deleteText}
                  startIndex={startIndex}
                  isfilterOn={isfilterOn}
                  filterValue={filterValue}
                />
              </div>
            )}
            {QRCodeURL && (
              <div className="">
                <ShowQRCode
                  isOpen={isQRCodeOpen}
                  onCancel={() => setIsQRCodeOpen(false)}
                  setIsOpen={setIsQRCodeOpen}
                  qrCodeValue={QRCodeURL}
                />
              </div>
            )}
            {editAppointmentOpen && (
              <>
                <EditAppointment
                  isOpen={editAppointmentOpen}
                  onCancel={() => setEditAppointmentOpen(false)}
                  setIsOpen={setEditAppointmentOpen}
                  startIndex={startIndex}
                  isfilterOn={isfilterOn}
                  filterValue={filterValue}
                />
              </>
            )}
            {isnotificationHistoryOpen && (
              <>
                <NotificationHistory
                  isOpen={isnotificationHistoryOpen}
                  setIsOpen={setIsnotificationHistoryOpen}
                  record={storeRecord}
                  filteredData={filteredData}
                />
              </>
            )}

            <div className="mt-5 ant-table rounded-xl shadow-xl">
              <Table
                className={'appointment-page-table'}
                rowClassName={(record) => {
                  let rowClass = '';

                  if (
                    record?.intakeStatus === 'Completed' ||
                    record?.intakeStatus === 'InProgress'
                  ) {
                    rowClass = 'hoverable-row';
                  }
                  if (record?.isExpired) {
                    rowClass = 'expired-row';
                  }
                  return rowClass.trim();
                }}
                data={filteredData}
                columns={columns(
                  filteredData,
                  onCellClick,
                  practitionersAndPatients,
                  currentPractitioner,
                  hasVCAProcessedWorkflowAccess,
                  setDeleteText,
                  setIsDeleteOpen,
                  setQRCodeURL,
                  setIsQRCodeOpen,
                  setEditAppointmentOpen,
                  setIsnotificationHistoryOpen,
                  setShowConvertAppointmentToAuraModal,
                  setSelectedAppointmentForAuraEncounter,
                  setFilteredData,
                  setData,
                  setStoreRecord
                )}
                items={false}
                loading={
                  apptsAPICall && getAppointmentStatusList?.length === 0
                    ? !isLoading
                    : isLoading
                }
                locale={{ emptyText: 'No Data' }}
                additionalPatientInfo={showPatientResetLink ? true : false}
                handleReset={handleReset}
                remainderPatientAppts={remainderPatientAppts}
              />
              <div className="flex justify-center items-center mt-4">
                <p>
                  {filteredData?.length > 0
                    ? `Showing ${filteredData?.length} of ${
                        filteredApptsTotal
                          ? filteredApptsTotal
                          : filteredData?.length < itemsPerPage
                            ? filteredData?.length
                            : apptsTotal
                      } `
                    : ''}{' '}
                </p>
              </div>
              {filteredData?.length > 0 && (
                <div className="flex justify-center items-center ">
                  <Progress
                    percent={beforepercent * 100}
                    strokeColor="#00D090"
                    showInfo={false}
                    size="small"
                    style={{
                      width: '200px',
                      height: '2px',
                    }}
                  />
                </div>
              )}
              <div className=" flex justify-center items-center p-4 mt-2">
                {filteredData?.length > 0 &&
                  filteredData.length >= itemsPerPage &&
                  (filteredApptsTotal != null
                    ? filteredApptsTotal
                    : apptsTotal) >= startIndex && (
                    <button
                      onClick={handleShowMore}
                      disabled={isLoading}
                      className="show-more-button bg-[#00D090] rounded-full hover:bg-[#059669] text-white font-semibold  mb-10 p-2 py-2 px-16"
                    >
                      {isLoading ? (
                        <Bars
                          height="25"
                          width="25"
                          color="#ffffff"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=" justify-center"
                          visible={true}
                        />
                      ) : (
                        'Show More'
                      )}
                    </button>
                  )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AppointmentsMobilePage;
